import React from 'react';
import TopicLayout from '../Js_files/Topic_layout';
import Navbar from './Navbar';
import Footer from './Footer';
import { useEffect, useState } from 'react';
import EnrollForm from './Enroll';


const File4= () => {
   const [showScrollTop, setShowScrollTop] = useState(false);
    const [showForm, setShowForm] = useState(false); // ✅ Control form visibility
            useEffect(() => {
          const handleScroll = () => {
            setShowScrollTop(window.scrollY > 200);
          };
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
        }, []);
      
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
  const topics = [
    {
      title: "Communication Systems",
      description: "Study of analog and digital communication, modulation techniques, and wireless communication protocols.",
      tags: ["Modulation", "Wireless", "Protocols", "Signal Processing"]
    },
    {
      title: "Signal Processing",
      description: "Digital and analog signal processing techniques, filtering, and signal analysis methods.",
      tags: ["DSP", "Filtering", "FFT", "Image Processing"]
    },
    {
      title: "Microwave Engineering",
      description: "High-frequency circuits, antennas, and microwave communication systems design and analysis.",
      tags: ["Antennas", "RF Circuits", "Waveguides", "Radar"]
    },
    {
      title: "VLSI Design",
      description: "Very Large Scale Integration design, digital circuit design, and semiconductor device physics.",
      tags: ["IC Design", "CMOS", "Layout", "Verification"]
    },
    {
      title: "Control Systems",
      description: "Automatic control theory, feedback systems, and modern control techniques for various applications.",
      tags: ["Feedback", "Stability", "PID Control", "State Space"]
    },
    {
      title: "Embedded Systems",
      description: "Microcontroller programming, real-time systems, and IoT device development.",
      tags: ["Microcontrollers", "Real-time", "IoT", "Sensors"]
    }
  ];

  const resources = [
    {
      icon: "📡",
      title: "Simulation Tools",
      description: "MATLAB, Simulink, and specialized RF/microwave simulation software for system design and analysis."
    },
    {
      icon: "🔬",
      title: "Lab Equipment",
      description: "Oscilloscopes, spectrum analyzers, and signal generators for hands-on learning and testing."
    },
    {
      icon: "💻",
      title: "Design Software",
      description: "CAD tools for PCB design, IC layout, and electromagnetic simulation software."
    },
    {
      icon: "📚",
      title: "Research Papers",
      description: "Latest research in communication technologies, signal processing, and emerging ECE fields."
    }
  ];

  const careerPaths = [
    {
      title: "RF Engineer",
      description: "Design and develop radio frequency systems, antennas, and wireless communication devices.",
      skills: ["RF Design", "Antenna Theory", "Microwave Engineering", "Testing"]
    },
    {
      title: "Signal Processing Engineer",
      description: "Develop algorithms for digital signal processing in audio, video, and communication applications.",
      skills: ["DSP Algorithms", "MATLAB", "C/C++", "Mathematical Analysis"]
    },
    {
      title: "VLSI Design Engineer",
      description: "Design integrated circuits and semiconductor devices for various electronic applications.",
      skills: ["IC Design", "Verilog/VHDL", "Layout Design", "Verification"]
    },
    {
      title: "Telecommunications Engineer",
      description: "Work on communication networks, protocols, and infrastructure for telecom companies.",
      skills: ["Network Protocols", "Wireless Systems", "Fiber Optics", "System Integration"]
    }
  ];

  return (
    <>
      <Navbar onEnrollClick={() => setShowForm(true)}/>
    <TopicLayout
      title="Electronics & Communication Engineering"
      icon="📡"
      color="#45B7D1"
      description="Understand communication systems, signal processing, and wireless technologies. Explore the fundamentals of electronics that power our connected world and emerging IoT applications."
      topics={topics}
      resources={resources}
      careerPaths={careerPaths}
    />
    <Footer/>

       <a
        href="https://wa.me/9042857947"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
      {/* Scroll to Top */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">s
          <i className="fas fa-arrow-up"></i>
        </div>
      )}

      {/* ✅ Enroll Form Overlay */}
      {showForm && <EnrollForm onClose={() => setShowForm(false)} />}
    </>
  );
};

export default File4;